/* SLP accordion. Attaches to every [data-slp-accordion].
   Hooks: [data-slp-accordion-button] (a <button> with aria-expanded and aria-controls pointing at its panel).
   One panel open at a time; the markup decides which one starts open. Clicking the open question closes it.
   Keyboard: Enter / Space toggle (native button), Arrow Up / Down move between questions, Home / End jump.
   Each accordion binds once, guarded by data-slp-init, so loading this file twice is harmless. */
(function () {
  'use strict';

  function setup(root) {
    if (root.hasAttribute('data-slp-init')) return;
    root.setAttribute('data-slp-init', '');

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-slp-accordion-button]'));
    if (!buttons.length) return;

    function panelFor(button) {
      return document.getElementById(button.getAttribute('aria-controls'));
    }

    function setOpen(button, open) {
      var panel = panelFor(button);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.hidden = !open;
    }

    buttons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        var willOpen = button.getAttribute('aria-expanded') !== 'true';
        buttons.forEach(function (other) { setOpen(other, false); });
        setOpen(button, willOpen);
      });

      button.addEventListener('keydown', function (event) {
        var target = null;
        if (event.key === 'ArrowDown') target = buttons[(index + 1) % buttons.length];
        else if (event.key === 'ArrowUp') target = buttons[(index - 1 + buttons.length) % buttons.length];
        else if (event.key === 'Home') target = buttons[0];
        else if (event.key === 'End') target = buttons[buttons.length - 1];
        if (target) {
          event.preventDefault();
          target.focus();
        }
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-slp-accordion]'), setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
